import React, { useContext, useMemo } from 'react';
import { filter, get } from 'lodash';

import { DropdownMediumWidth } from 'src/presentation/components/forms/Dropdown';
import endpointsResource from 'src/actions/endpoints/endpointsResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { formatPhone } from 'src/actions/shared/phonesHelper';
import FormContext from 'src/presentation/contexts/FormContext';
import { STATUS_SUCCEEDED, useResourceAll } from 'src/presentation/hooks/useResource';
import useGetEndpointWithInbox from 'src/presentation/components/pages/shared/hooks/useGetEndpointWithInbox';

type EndpointsDropdownType = {
  attr: string;
  tooltipMessage?: string;
  label: string;
  placeholder?: string;
  endpointType: EndpointTypes;
  description?: string;
};

const EndpointsDropdown = ({ attr, label, placeholder, endpointType, description }: EndpointsDropdownType) => {
  const { workingState } = useContext(FormContext);
  const { address, inboxName } = useGetEndpointWithInbox({ endpointId: get(workingState, attr) });
  const { values: endpoints = [], loadingState: endpointsLoadingState } = useResourceAll(endpointsResource);

  const endpointOptions = useMemo(
    () =>
      filter(endpoints, endpoint => endpoint.type === endpointType).map(endpoint => ({
        label: [EndpointTypes.SMS, EndpointTypes.VOICE].includes(endpointType)
          ? formatPhone(endpoint.address)
          : endpoint.address,
        value: endpoint.id,
        text: endpoint.address,
      })),
    [endpoints, endpointType]
  );

  const displayDescription = useMemo(() => {
    if (inboxName) {
      const endpoint = [EndpointTypes.SMS, EndpointTypes.VOICE].includes(endpointType) ? formatPhone(address) : address;

      return `${description} ${endpoint} goes to the Inbox${inboxName.includes(', ') ? 'es' : ''} ${inboxName}.`;
    }
    return description;
  }, [address, description, endpointType, inboxName]);

  return (
    <DropdownMediumWidth
      attr={attr}
      className="endpoint-dropdown"
      description={displayDescription}
      data-aid="campaigns-endpoint-dropdown"
      disabled={endpointsLoadingState !== STATUS_SUCCEEDED}
      label={label}
      options={endpointOptions}
      placeholder={placeholder}
      searchable
    />
  );
};

export default EndpointsDropdown;
